import contentWrapperConfig from '@nile/home/src/Constants/contentWrapper';
import { Checkbox, TextField } from '@superops/ui-design-system';
import * as _ from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ContentWrapper } from 'sopslibrary';

export default function CustomPasswordConfig(props) {
  const { config: policy, handleChange } = props;

  const keys = Object.keys(policy);

  const { gapWithinNestedSection, defaultClasses } = contentWrapperConfig;

  return (
    <div>
      <ContentWrapper
        className={`${defaultClasses} white-transparent-bg`}
        gap={gapWithinNestedSection}
        nopadding
      >
        {keys.map((key) => {
          switch (key) {
            case 'passwordPolicyType':
              break;
            case 'length':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed">
                    <FormattedMessage id="admin.passwordPolicy.passwordLength" />
                  </div>
                  <div className="flex-item-fixed custom-password-input-block bold">
                    <TextField
                      type="number"
                      value={policy.length.toString()}
                      onChange={(value) => {
                        handleChange('length', _.toNumber(value));
                      }}
                    />
                  </div>
                  <div className="flex-item-fixed bold">
                    {' '}
                    <FormattedMessage id="admin.passwordPolicy.characters" />
                  </div>
                </div>
              );
            case 'isAlphaNumeric':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed mr8">
                    <FormattedMessage id="admin.passwordPolicy.alphaNumeric" />{' '}
                  </div>
                  <div className="flex-item-fixed">
                    <Checkbox
                      checked={policy.isAlphaNumeric}
                      onChange={(value) => {
                        handleChange('isAlphaNumeric', value);
                      }}
                    />
                  </div>
                </div>
              );
            case 'isMixCaseWithSpecialChar':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed mr8">
                    <FormattedMessage id="admin.passwordPolicy.specialChars" />{' '}
                  </div>
                  <div className="flex-item-fixed">
                    <Checkbox
                      checked={policy.isMixCaseWithSpecialChar}
                      onChange={(value) => {
                        handleChange('isMixCaseWithSpecialChar', value);
                      }}
                    />
                  </div>
                </div>
              );
            case 'checkEmailMatch':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed mr8">
                    <FormattedMessage id="admin.requesterLogin.emailShouldNotMatch" />{' '}
                  </div>
                  <div className="flex-item-fixed">
                    <Checkbox
                      checked={policy.checkEmailMatch}
                      onChange={(value) => {
                        handleChange('checkEmailMatch', value);
                      }}
                    />
                  </div>
                </div>
              );
            // spelling of attempt is wrong here, since we are getting this object from server, once it is changed in server, we have to change in client as well
            case 'allowedFailureAtempt':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed">
                    <FormattedMessage id="admin.passwordPolicy.lockUserAccountAfter" />
                  </div>
                  <div className="flex-item-fixed custom-password-input-block bold">
                    <TextField
                      type="number"
                      value={policy.allowedFailureAtempt.toString()}
                      onChange={(value) => {
                        handleChange('allowedFailureAtempt', _.toNumber(value));
                      }}
                    />
                  </div>
                  <div className="flex-item-fixed bold">
                    {' '}
                    <FormattedMessage id="admin.passwordPolicy.unsuccessfulAttempts" />
                  </div>
                </div>
              );
            case 'checkPrevPasswordMatchCount':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed">
                    <FormattedMessage id="admin.passwordPolicy.notMatchPrevious" />{' '}
                  </div>
                  <div className="flex-item-fixed custom-password-input-block bold">
                    <TextField
                      type="number"
                      value={policy.checkPrevPasswordMatchCount.toString()}
                      onChange={(value) => {
                        handleChange(
                          'checkPrevPasswordMatchCount',
                          _.toNumber(value)
                        );
                      }}
                    />
                  </div>
                  <div className="flex-item-fixed bold">
                    {' '}
                    <FormattedMessage id="admin.passwordPolicy.passwords" />
                  </div>
                </div>
              );
            case 'passwordExpiryDays':
              return (
                <div className="flex-row flex-align-center">
                  <div className="flex-item-fixed">
                    <FormattedMessage id="admin.passwordPolicy.passwordExpiryAfter" />{' '}
                  </div>
                  <div className="flex-item-fixed custom-password-input-block bold">
                    <TextField
                      type="number"
                      value={policy.passwordExpiryDays.toString()}
                      onChange={(value) => {
                        handleChange('passwordExpiryDays', _.toNumber(value));
                      }}
                    />
                  </div>
                  <div className="flex-item-fixed bold">
                    {' '}
                    <FormattedMessage id="admin.passwordPolicy.days" />
                  </div>
                </div>
              );
            default:
              break;
          }
        })}
      </ContentWrapper>
    </div>
  );
}
